import React, { useEffect, useState, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import { Box } from 'reflexbox';
import { LinearProgress } from '@material-ui/core';
import { useParams } from 'react-router';

import campaignsAPI from '../../../apis/campaigns';
import EditPushNotification from './components/EditPushNotification';

const PushNotificationDetailsContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [campaign, setCampaign] = useState(null);
  const [appDeepLinks, setAppDeepLinks] = useState(null);
  const [updateError, setUpdateError] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);

  const { campaignId } = useParams();

  useEffect(() => {
    const fetchCampaign = async () => {
      setLoading(true);

      const response = await campaignsAPI.getCampaign(campaignId);
      setCampaign(response.data?.data);

      const deepLinksResponse = await campaignsAPI.getAppDeepLinks();
      setAppDeepLinks(deepLinksResponse.data?.data);
      setLoading(false);
    };

    fetchCampaign();
  }, [campaignId]);

  const handleSubmit = useCallback(async (payload) => {
    const { _id, ...updatedFields } = payload;
    try {
      const formData = new FormData();
      Object.keys(updatedFields).forEach(fieldName => {
        formData.append(fieldName, updatedFields[fieldName]);
      });

      setIsUpdating(true);
      const response = await campaignsAPI.updateCampaign(_id, formData);
      if (response) {
        enqueueSnackbar('Campaign updated successfully!', { variant: 'success' });
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
      setUpdateError(error.message);
    } finally {
      setIsUpdating(false);
    }
  }, [enqueueSnackbar]);

  if (!campaign) return <p>Campaign not found</p>;

  return (
    <>
      {loading ? (
        <Box sx={{ width: '50%' }}>
          <LinearProgress color='secondary' />
        </Box>
      ) : (
        <EditPushNotification
          campaign={campaign}
          appDeepLinks={appDeepLinks}
          isUpdating={isUpdating}
          onSubmit={handleSubmit}
          error={updateError}
        />
      )}
    </>
  );
};

export default PushNotificationDetailsContainer;
